((Drupal) => {
  Drupal.behaviors.ouigoBloc1Colonne = {
    attach: (context) => {
      const wrappers = context.querySelectorAll(
        '.bloc-1-colonne__video-ratio:not([data-video-bound])'
      );

      wrappers.forEach((wrapper) => {
        wrapper.setAttribute('data-video-bound', 'true');
        const video = wrapper.querySelector('.bloc-1-colonne__video');
        const btn = wrapper.querySelector('.bloc-1-colonne__play-btn');
        const fullscreenBtn = wrapper.querySelector('.bloc-1-colonne__fullscreen-btn');

        if (!video || !btn) return;

        const setPlaying = () => {
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', Drupal.t('Pause the video'));
        };
        const setPaused = () => {
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', Drupal.t('Play the video'));
        };

        // Synchroniser le bouton avec les événements natifs de la vidéo.
        video.addEventListener('play', setPlaying);
        video.addEventListener('pause', setPaused);
        video.addEventListener('ended', setPaused);

        // Clic sur le bouton (vidéo en pause → lecture) OU sur l'icône (vidéo en lecture → pause).
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => setPaused());
            }
          } else {
            video.pause();
          }
        });

        // État initial : si l'autoplay est bloqué par le navigateur, corriger le bouton.
        if (video.paused) {
          setPaused();
        } else {
          setPlaying();
        }

        // Bouton plein écran.
        if (fullscreenBtn) {
          fullscreenBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            event.preventDefault();
            if (video.requestFullscreen) {
              video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) {
              video.webkitRequestFullscreen();
            } else if (video.webkitEnterFullscreen) {
              video.webkitEnterFullscreen();
            }
          });
        }
      });
    },
  };
})(Drupal);
